var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ChartTimelineIcon = function (_a) {
    var width = _a.width, height = _a.height, _b = _a.color, color = _b === void 0 ? 'currentColor' : _b;
    return (_jsx("svg", __assign({ className: "inline-block", xmlns: "http://www.w3.org/2000/svg", id: "mdi-chart-timeline", viewBox: "0 0 24 24", fill: color, width: width, height: height }, { children: _jsx("path", { d: "M2,2H4V20H22V22H2V2M7,10H17V13H7V10M11,15H21V18H11V15M6,4H22V8H20V6H8V8H6V4Z" }) })));
};
export default ChartTimelineIcon;
